module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst-norming.304f7712.mp3";